/**
 * Branding lives here and only here. "Last Call" is the software's working name; the venue
 * branding (logo and colours) is Red's Bar and Grill. Change these values and the app
 * title, PWA manifest, printed report headers, and export file names follow.
 *
 * The logo files and icons are generated from brand-assets/reds-logo-source.png by
 * tools/make-brand-assets.py. The screen colours are the tokens in src/index.css.
 *
 * This file is also imported by vite.config.ts (for the manifest), so keep it free of
 * browser-only code.
 */
export const brand = {
  /** Software name, shown on reports next to the venue name. */
  name: 'Last Call',
  /** Short name under the home-screen icon (keep it under ~12 characters). */
  shortName: 'Last Call',
  tagline: 'Nightly counts without the paper.',
  /** Prefix for exported files, e.g. "last-call-stock-2026-10-09.csv". */
  filePrefix: 'last-call',
  /** The venue the app is branded for. */
  business: "Red's Bar and Grill",
  /** Logo for light screens, and a version with white lettering for dark screens. */
  logo: '/brand/logo.png',
  logoDark: '/brand/logo-dark.png',
  /** Red from the logo (#b5292f); the black is pure black. */
  red: '#b5292f',
  /** Browser chrome / PWA splash. */
  themeColor: '#ffffff',
  backgroundColor: '#ffffff',
} as const;

export type Brand = typeof brand;
